<template>
    <div>
        <br>
        <nav class="navbar navbar-expand-lg navbar-light" v-if="canViewDriverAll">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchDriverBonus" class="form-inline">
                    <input class="form-control mr-sm-2"
                           type="search"
                           v-model="search.driver_name"
                           placeholder="ชื่อคนขับ"
                           aria-label="Search"
                    />
                    <b-form-select v-model="search.transport_type"
                                   :options="transportType" >
                    </b-form-select>&nbsp
                    <date-picker
                            v-model="search.date"
                            type="date"
                            :format="changeFormat"
                            :lang="lang"
                            range
                            confirm
                            placeholder="วันที่เริ่มต้น - สิ้นสุด" >
                    </date-picker>
                    &nbsp;
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchDriverBonus"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp;
                    <button class="btn btn-primary my-2 my-sm-0"
                            @click="printDriverBonus"
                            type="button">
                        <icon name="print"></icon>
                        พิมพ์โบนัส
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ชื่อ-นามสกุล</th>
                    <th scope="col">ทะเบียนรถ</th>
                    <th scope="col">ประเภทรถ</th>
                    <th scope="col">ยอดเงิน</th>
                    <th scope="col">สถานะการจ่าย</th>
                    <th scope="col">วันที่รับเงิน</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in driver_bonus">
                    <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                    <td>
                        <template v-if="data.driver">
                            {{data.driver.name}}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <template v-if="data.driver">
                            {{data.driver.license_plate}}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <template v-if="data.driver.transport_type && data.driver">
                            {{data.driver.transport_type.name}}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>{{data.amount | currency }}</td>
                    <td>
                        <template v-if="data.status==1 && canViewDriverAll">
                            <a @click="showDriverBonus(data.id)" style="color: red ;text-decoration:underline">
                                {{data.status_name}}
                            </a>
                        </template>
                        <template v-else>
                        <span style="color: green ;">
                            {{data.status_name}}
                        </span>
                        </template>
                    </td>
                    <td>{{data.date | moment("DD/MM/YYYY")}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="driver_bonus.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getDriverBonusPage">
            </vue-pagination>
        </div>
        <br>
        <b-modal hide-header hide-footer
                 ref="edit_status">
            <div style="text-align: center;">
                <driver-bonus-status @submit="saveStatusFormSubmit">

                </driver-bonus-status>
            </div>
        </b-modal>
    </div>
</template>


<script>
import {mapState} from "vuex";
import DriverBonusStatus from "./DriverBonusStatus";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import {canViewDriver, canViewDriverAll,} from "../../../util/Permissions";
import {domain} from "../../../util/Constants";

export default {
        components: {
            VuePagination,
            DriverBonusStatus,
            DatePicker
        },
        name: "driver-bonus-list",
        data(){
            return{
                search :{
                    driver_name:"",
                    transport_type:"",
                    date:[],
                    status:""
                },
                options: [
                    { text : 'ค้นหาสถานะ' ,value : ""},
                    { text: 'รอชำระ', value: 1 },
                    { text: 'ชำระเรียบร้อย', value: 2 }
                ],
                event_submit : false,
                dateFormat: 'D MMM YYYY',
                changeFormat: {
                    stringify: (date) => {
                        if(date && moment(date).format('MM') == '02' && moment(date).format('DD') == '29')
                          return '29/02/' + moment(date).add(543, 'y').format('YYYY');
                      return date ? moment(date).add(543, 'y').format('DD/MM/YYYY') : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            }
        },
        created(){
            this.$store.dispatch("DriverBonus/setDriverBonus",{'page':1,'id':this.user.id});
        },
        computed:{
            canViewDriver,
            canViewDriverAll,
            ...mapState({
                driver_bonus :state=>{
                    return state.DriverBonus.bonusList;
                },
                dataPaginate:state=>{
                    return state.DriverBonus.dataPaginate;
                },
                transportType:state=>{
                    return [
                        {
                            value: "",
                            text: "ค้นหาประเภทรถ"
                        },
                        ...state.TransportType.transportTypeList.map(type => ({
                            value: type.id,
                            text: type.name
                        }))
                    ];
                },
                user:state=>{
                    return state.Auth.user;
                },
            })
        },
        methods:{
            showStatusModal(){
                this.$refs.edit_status.show();
            },
            hideStatusModal(){
                this.$refs.edit_status.hide();
            },
            showDriverBonus(id){
                this.$store.dispatch('DriverBonus/show',id)
                    .then(()=>{
                        this.showStatusModal();
                    });
            },
            saveStatusFormSubmit(submitData){
                if(submitData!=0){
                    this.$store.dispatch('DriverBonus/save',{
                        id : submitData.id,
                        data : submitData
                    }).then(()=>{
                        this.hideStatusModal();
                    }).then(()=>{
                        this.$store.dispatch("DriverBonus/setDriverBonus");
                    })
                }else{
                    this.hideStatusModal();
                }
            },
            searchDriverBonus(){
                let start_date = '';
                let end_date = '';
                if(this.search.date.length > 0 && this.search.date[0]){
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                }else{
                    this.search.date = [];
                }
                this.event_submit = true;
                this.$store.dispatch('DriverBonus/search',{
                    data : this.search
                });
            },
            getDriverBonusPage(){
                const page = this.dataPaginate.current_page;
                if(this.search.date){
                    this.search.date = moment(this.search.date).format("YYYY-MM-DD");
                }
                if(this.event_submit){
                    this.$store.dispatch('DriverBonus/search',{
                        page : page,
                        data : this.search
                    })
                }
                else{
                    this.$store.dispatch("DriverBonus/setDriverBonus",page);
                }
            },
            formatDates(dateOne) {
                let formattedDates = ''
                if (dateOne) {
                    formattedDates = format(dateOne, this.dateFormat)
                }
                return formattedDates
            },
            printDriverBonus(){
                if(this.search.date.length < 1){
                    alert("กรุณาเลือกวันที่")
                }else if(!this.search.transport_type){
                    alert('เลือกประเภทคนขับ')
                }else{
                    let start_date = this.search.date.length > 0 && this.search.date[0] ? moment(this.search.date[0]).format("YYYY-MM-DD") : '';
                    let end_date = this.search.date.length > 0 && this.search.date[1] ? moment(this.search.date[1]).format("YYYY-MM-DD") : '';
                    window.open( `${domain}/report_driver_bonus/${this.search.status}?` +
                        `start_date=${start_date}&end_date=${end_date}`+
                        `&transport_type=${this.search.transport_type}`,
                        '_blank');
                }

            }
        }
    }
</script>

<style scoped>

</style>
